
import ShortcutPanelCard from './ShortcutPanelCard.vue';

export default {
  components: {
    ShortcutPanelCard,
  },
  data() {
    return {
      cards: [
        {
          title: 'Demonstrativo',
          icon: 'insert_drive_file',
          color: '#6677a3',
          contentColor: 'white',
          notification: '',
          link: 'demonstrativo',
          size: 2,
        },
        {
          title: 'Registro de Ponto',
          icon: 'add_circle',
          color: '#6677a3',
          contentColor: 'white',
          notification: '',
          link: 'registroPontoUnidade',
          size: 2,
        },
      ],
    };
  },
};
